export default {
  getModuleProcess: state => state.moduleProcess,
};
